import { css } from '@emotion/css';

import { listItemHoverStyles } from '@/utils/styles';

export const listItemStyle = css`
  :last-child {
    border: none;
  }
  :hover {
    ${listItemHoverStyles}
  }
`;
